import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';
import SettingsInputAntennaRoundedIcon from '@mui/icons-material/SettingsInputAntennaRounded';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { AMBER, FONT_BODY, FONT_DISPLAY, Reveal, SectionHeading, glassCardSx, gridLayerSx } from './LandingKit';

const pains = [
  {
    icon: <SettingsInputAntennaRoundedIcon />,
    title: 'Rastreador custa caro',
    description:
      'Comprar, instalar e manter um aparelho por veículo pesa no bolso. E ele some quando o motorista troca de carro.',
  },
  {
    icon: <AccessTimeRoundedIcon />,
    title: 'O dado chega tarde',
    description:
      'A planilha de coletas só aparece no fim do dia, quando já não dá mais para agir sobre o que deu errado.',
  },
  {
    icon: <ReceiptLongRoundedIcon />,
    title: 'Saber como foi dá trabalho',
    description:
      'Para responder "como está a operação hoje?" alguém precisa abrir três telas e juntar tudo na mão.',
  },
];

export default function Problem() {
  return (
    <Box id="problem" sx={{ position: 'relative', overflow: 'hidden' }}>
      <Box aria-hidden sx={gridLayerSx} />
      <Container sx={{ position: 'relative', py: { xs: 8, sm: 14 } }}>
        <Reveal>
          <Box sx={{ mb: { xs: 5, sm: 7 } }}>
            <SectionHeading
              overline="O PROBLEMA"
              accent={AMBER}
              title="Tocar coleta no escuro custa caro"
              subtitle="Quem coordena coletas conhece esses problemas de cor. O DriveSync resolve os três."
            />
          </Box>
        </Reveal>
        <Grid container spacing={2.5}>
          {pains.map((pain, i) => (
            <Grid size={{ xs: 12, md: 4 }} key={pain.title}>
              <Reveal delay={i * 0.08} sx={{ height: '100%' }}>
                <Stack
                  component={Card}
                  elevation={0}
                  direction="column"
                  spacing={1.5}
                  useFlexGap
                  sx={(theme) => ({ ...glassCardSx(theme), p: 3, height: '100%' })}
                >
                  <Box
                    aria-hidden
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: 40,
                      height: 40,
                      borderRadius: 1.5,
                      color: AMBER,
                      border: '1px solid',
                      borderColor: `${AMBER}44`,
                      backgroundColor: `${AMBER}12`,
                    }}
                  >
                    {pain.icon}
                  </Box>
                  <Typography
                    component="h3"
                    sx={(theme) => ({
                      fontFamily: FONT_DISPLAY,
                      fontWeight: 700,
                      fontSize: '1.1rem',
                      letterSpacing: '-0.01em',
                      color: '#071513',
                      ...theme.applyStyles('dark', { color: '#f2fbf9' }),
                    })}
                  >
                    {pain.title}
                  </Typography>
                  <Typography
                    sx={(theme) => ({
                      fontFamily: FONT_BODY,
                      fontSize: '0.95rem',
                      lineHeight: 1.5,
                      color: '#33514c',
                      ...theme.applyStyles('dark', { color: '#9fc4bd' }),
                    })}
                  >
                    {pain.description}
                  </Typography>
                </Stack>
              </Reveal>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
